import React from 'react';
import { Col, Row, Typography } from 'antd';
import { Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../../assets/logomain.png";
import playStore from "../../assets/playstore.png";
import appStore from "../../assets/appstore.png";
import "./footer.css";

const Footer = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  return (
    <>
      <section className='ninth_section'>
        <footer>
          <div style={{ background: "#FFFCEE", padding: "3rem 0 4rem 0" }}>
            <Container fluid className='fluid_content'>
              <div className="text-center mb-4" onClick={() => navigate('/dashboard')} style={{ cursor: "pointer" }}>
                <img src={logo} alt="logo" className='footer_image' />
              </div>
              <Row gutter={[0, 20]} className='text_content'>
                <Col xs={12} sm={12} md={6} lg={6} className="mx-auto footer_card_details link_tags trusted_text_subtitle">
                  <Link to={'/getstarted'}>Getting started</Link>
                  <Link to={token ? "/community" : "/login"}>Community</Link>
                  <Link to={token ? "/dashboard" : "/login"}>Dashboard</Link>
                  <Link to={token ? "/journal" : "/login"}>Journal</Link>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="mx-auto link_tags trusted_text_subtitle">
                  <Link to={"/products"}>Shop</Link>
                  <Link to={'/feedback'}>I'm Having Tech Issues</Link>
                  <Link to={'/blog'}>Blog</Link>
                  <Link to={token ? "/pricing" : "/subscription"}>Subscription</Link>
                  {/* <Link to={"/pricing"}>Subscription</Link> */}
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="link_tags trusted_text_subtitle">
                  <Link to={'/terms'}>Terms & Services</Link>
                  <Link to={'/about'}>About Us</Link>
                  <Link to={'/contact'}>Contact Us</Link>
                  <Link to={'/faq'}>FAQ</Link>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} className="link_tags trusted_text_subtitle">
                  {/* <Typography><a target='_blank' href="https://play.google.com/store/apps/details?id=com.bulletproofforbjj"><img src={playStore} alt="playStore" width={"50%"} /></a></Typography>
                  <Typography><a target='_blank' href="https://apps.apple.com/us/app/bulletproof-for-bjj/id6444311790"><img src={appStore} alt="appStore" width={"50%"} /></a></Typography> */}
                   <Link target='_blank' to={'https://app.termly.io/document/privacy-policy/ad20d2ff-cf3c-4f48-8e5b-ee36fc4c4f9e'}>Privacy & Policy</Link>
                </Col>
              </Row>
            </Container>
          </div>
        </footer>
      </section>
      <footer>
        <div style={{ background: "#1F1F1F", marginTop: "", padding: "1rem 0" }}>
          <Typography style={{ color: "#fff", textAlign: "center" }}>© 2021 - All Rights Reserved - Bulletproof for BJJ</Typography>
        </div>
      </footer>
    </>
  )
}

export default Footer